import { BrowserRouter, Route, Routes } from "react-router-dom";
import SpinWheel from "./SpinWheel";

function App() {
  return (
    <div
    className="overflow-x-hidden  h-screen pt-5  font-inter"
    >
    <BrowserRouter>


      <div className="">
      <Routes>
      <Route path='/*' element={<SpinWheel />} />
    </Routes>
      </div>
    </BrowserRouter>
    {/* <SpinWheel/> */}
    </div>

  );
}

export default App;
